import Button from 'core/display/buttons/Button'
import Image from 'core/display/Image'
import { signal } from 'services/SignalsService'

export default class DecreaseAutoButton {
  constructor(data) {
    this.self = new Button(data, new Image(data))
    this.images = this.self.images

    this.createSignal()

    return this.self
  }

  createSignal() {
    const self = this

    signal.on('MODEL:AUTO', function () {
      self.images[0].visible = game.models.AutoCountModel.getID() == 0
      self.images[1].visible = game.models.AutoCountModel.getID() != 0
    })
  }
}
